import { Link } from "react-scroll";
import styles from "../css/navbar.module.css";
import {
  Box,
  Flex,
  Avatar,
  HStack,
  IconButton,
  useDisclosure,
  useColorModeValue,
  Stack,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";

export const Navbar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  //   const onButtonClick = () => {

  //     fetch('Vinayak-Hiwse-Resume.pdf').then(response => {
  //         response.blob().then(blob => {

  //             const fileURL = window.URL.createObjectURL(blob);
  //             // Setting various property values
  //             let alink = document.createElement('a');
  //             alink.href = fileURL;
  //             alink.download = 'Vinayak Hiwse Resume.pdf';
  //             alink.click();
  //         })
  //     })
  // }

  const buttonClick = () => {
    window.open(
      "https://drive.google.com/drive/folders/1MvFHUOfZw7v6MLp6LJO704a6DS3fQvOW?usp=share_link"
    );
  };

  const Reload = () => {
    window.location.reload();
  };
  return (
    <> 
    {/* //"#FAF2E1", "#FAF2E1", */}
      <Box
        bg={useColorModeValue("#EDF2F8")}
        px={4}
        className={styles.mainBox}
      >
        <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
          <IconButton
            size={"md"}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack
            justifyContent={{ base: "center", md: "space-between" }}
            w={"100%"}
            p={4}
            spacing={8}
            alignItems={"center"}
          >
            <Box>
              <Avatar
                onClick={Reload}
                size={"lg"}
                src={
                  "https://images.assetsdelivery.com/compings_v2/wikagraphic/wikagraphic2010/wikagraphic201037624.jpg"
                }
              />
            </Box>
            <HStack
              as={"nav"}
              spacing={8}
              bg={"#EDF2F8"}
              display={{ base: "none", md: "flex" }}
            >
              <Link
                to="home"
                smooth={true}
                duration={1000}
                activeClass={styles.active}
                spy={true}
                hashSpy={true}
              >
                <div className={styles.nav}>Home</div>
              </Link>
              <Link
                to="about"
                smooth={true}
                duration={1000}
                activeClass={styles.active}
                spy={true}
                hashSpy={true}
              >
                <div className={styles.nav}>About</div>
              </Link>
              <Link
                to="skills"
                smooth={true}
                duration={1000}
                activeClass={styles.active}
                spy={true}
                hashSpy={true}
              >
                <div className={styles.nav}>Skills</div>
              </Link>
              <Link
                to="projects"
                smooth={true}
                duration={1000}
                activeClass={styles.active}
                spy={true}
                hashSpy={true}
              >
                <div className={styles.nav}>Projects</div>
              </Link>
              <Link
                to="contact"
                smooth={true}
                duration={1000}
                activeClass={styles.active}
                spy={true}
                hashSpy={true}
              >
                <div className={styles.nav}>Contact</div>
              </Link>
              <a download href="Vinayak-Hiwse-Resume.pdf" onClick={buttonClick}>
                <div className={styles.nav}>Resume</div>
              </a>
            </HStack>
          </HStack>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: "none" }}  >
            <Stack as={"nav"} spacing={4} bg="#EDF2F8">
              <Link
                to="home"
                smooth={true}
                duration={1000}
                activeClass={styles.active}
                spy={true}
                hashSpy={true}
              >
                <div className={styles.nav}>Home</div>
              </Link>
              <Link
                to="about"
                smooth={true}
                duration={1000}
                activeClass={styles.active}
                spy={true}
                hashSpy={true}
              >
                <div className={styles.nav}>About</div>
              </Link>
              <Link
                to="skills"
                smooth={true}
                duration={1000}
                activeClass={styles.active}
                spy={true}
                hashSpy={true}
              >
                <div className={styles.nav}>Skills</div>
              </Link>
              <Link
                to="projects"
                smooth={true}
                duration={1000}
                activeClass={styles.active}
                spy={true}
                hashSpy={true}
              >
                <div className={styles.nav}>Projects</div>
              </Link>
              <Link
                to="contact"
                smooth={true}
                duration={1000}
                activeClass={styles.active}
                spy={true}
                hashSpy={true}
              >
                <div className={styles.nav}>Contact</div>
              </Link>
              <a download href="Vinayak-Hiwse-Resume.pdf" onClick={buttonClick}>
                <div className={styles.nav}>Resume</div>
              </a>
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
};
